export const ACTIVITY_TRANSLATION_KEYS = [
  "alpine_skiing",
  "american_football",
  "badminton",
  "bandy",
  "baseball",
  "basketball",
  "beach_volleyball",
  "biathlon",
  "cricket",
  "dancing_and_cheer",
  "esports",
  "football",
  "athletics",
  "volunteering",
  "golf",
  "gymnastics",
  "equestrian_sports",
  "handball",
  "floorball",
  "ice_hockey",
  "martial_arts",
  "lacrosse",
  "field_hockey",
  "cc_skiing",
  "motorsport",
  "music",
  "netball",
  "rugby",
  "school",
  "shooting_sports",
  "softball",
  "social",
  "scouting",
  "swimming",
  "cycling",
  "tennis",
  "water_sports",
  "volleyball",
  "sailing",
  "skijumping",
  "multisport",
  "bowling",
  "orienteering",
  "squash",
  "snowboarding",
  "skating",
  "figureskating",
  "pingpong",
  "yoga",
  "rowing",
  "running",
  "sup",
  "surfing",
  "gaelicfootball",
  "hurling",
  "pickleball",
  "padel",
  "discgolf",
  "fencing",
  "other_sports",
  "other_non_sports",
] as const;
